import { LinearProgress, MuiThemeProvider } from '@material-ui/core'
import React, { Suspense, useEffect, useState } from 'react'
import DefaultLayout from '../../pages/_layouts/default/defaultLayout'
import { theme as defaultTheme } from '../../themes/default/theme'
//import { NotifyProvider } from '@globaleris/ui.library';

import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { HelpLayout } from '../../pages'
import { EmptyLayout } from '../../pages/_layouts/empty/emptyLayout'
import { getUserName, RootStoreModel } from '../../redux'
import { removeState } from '../../redux/localStorage'

import { InteractionStatus, InteractionType } from '@azure/msal-browser'
import {
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal
} from '@azure/msal-react'
import { loginRequest } from '../../auth/auth.config'
import { logout } from '../../auth/auth.service'
import { ProcessingNotificationManager } from '../processingNotification/processingNotificationManager'

function getFaviconEl() {
  return document.getElementById('favicon')
}

function App() {
  const [customTheme, setCustomTheme] = React.useState(defaultTheme)
  const favicon = useSelector(
    (state: RootStoreModel) => state.profile && state.profile.user?.favicon
  )

  const theme = useSelector((state: RootStoreModel) => state.profile && state.profile.user?.theme)

  const { accounts, instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      if (accounts.length > 0) {
        setIsLoading(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, inProgress, instance])

  useEffect(() => {
    import(/* webpackMode: "eager" */ `../../themes/${theme}/theme.ts`)
      .then(loadedModule => {
        setCustomTheme(loadedModule.theme)
      })
      .catch(() => {
        // No theme was found for the current url Host. Default theme will be used.
      })

    const faviconEl = getFaviconEl()
    if (faviconEl !== null && favicon !== null)
      faviconEl.setAttribute('href', process.env.PUBLIC_URL + `/favicons/${favicon}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favicon])

  return (
    <>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      >
        <MuiThemeProvider theme={customTheme}>
          <Suspense fallback={<LinearProgress />}>
            {
              !isLoading && (
                //<NotifyProvider>
                <>
                  <Switch>
                    <Route
                      path="/error/"
                      render={() => (
                        <EmptyLayout logoutHandler={logout} email={getUserName() ?? ''} />
                      )}
                    ></Route>
                    <Route path="/help/:wikiPath" render={() => <HelpLayout />}></Route>
                    <Route path="/" render={() => <DefaultLayout logoutHandler={logout} />}></Route>
                  </Switch>
                  {/* Manager de notificaciones flotantes que persiste en todas las páginas */}
                  <ProcessingNotificationManager />
                </>
              )
              //</NotifyProvider>
            }
          </Suspense>
        </MuiThemeProvider>
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate>
        {removeState()}
        <MuiThemeProvider theme={customTheme}>
          <LinearProgress />
        </MuiThemeProvider>
      </UnauthenticatedTemplate>
    </>
  )
}

export default App
